import {
  vEmailOrEmpty,
  vNonEmptyString,
  vObject,
  vOmit,
  vOptional,
  type vOutput,
  vString,
} from '../validation/index.ts'
import {
  vCountryUpper,
  vPhoneExt,
  vPhoneNumber,
} from '../validation/schema/custom.ts'
import { addressBaseSchema } from './address.ts'

export const billToSchema = vObject({
  ...addressBaseSchema.entries,
  _id: vOptional(vString()),
  company: vNonEmptyString(),
  contactName: vOptional(vString()),
  contactPhone: vOptional(vPhoneNumber()),
  contactPhoneExt: vOptional(vPhoneExt()),
  contactEmail: vOptional(vEmailOrEmpty),
  accountNumber: vOptional(vString()),
})

export type IBillTo = vOutput<typeof billToSchema>

export const accountBillToSchema = vObject({
  ...vOmit(billToSchema, ['accountNumber']).entries,
  contactName: vNonEmptyString(),
  country: vCountryUpper,
})
export type AccountBillTo = vOutput<typeof accountBillToSchema>

export const accountBillToRequestSchema = vObject({
  ...vOmit(accountBillToSchema, ['_id']).entries,
})
export type AccountBillToRequestModel = vOutput<
  typeof accountBillToRequestSchema
>
